import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _79a7ced0 = () => interopDefault(import('../../../pages/documentation/index.vue' /* webpackChunkName: "pages/documentation/index" */))
const _0e03a9b6 = () => interopDefault(import('../../../pages/index.vue' /* webpackChunkName: "pages/index" */))
const _05a04f3f = () => interopDefault(import('../../../pages/profile/index.vue' /* webpackChunkName: "pages/profile/index" */))
const _d42a69a8 = () => interopDefault(import('../../../pages/stock/index.vue' /* webpackChunkName: "pages/stock/index" */))
const _52dcac02 = () => interopDefault(import('../../../pages/auth/login.vue' /* webpackChunkName: "pages/auth/login" */))
const _76201b55 = () => interopDefault(import('../../../pages/profile/notifications.vue' /* webpackChunkName: "pages/profile/notifications" */))
const _692c6284 = () => interopDefault(import('../../../pages/profile/password.vue' /* webpackChunkName: "pages/profile/password" */))
const _715e7314 = () => interopDefault(import('../../../pages/tasks/archive.vue' /* webpackChunkName: "pages/tasks/archive" */))
const _66b52835 = () => interopDefault(import('../../../pages/tasks/schedule.vue' /* webpackChunkName: "pages/tasks/schedule" */))
const _608e796c = () => interopDefault(import('../../../pages/tasks/_uuid.vue' /* webpackChunkName: "pages/tasks/_uuid" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/documentation",
    component: _79a7ced0,
    name: "documentation___uk"
  }, {
    path: "/en",
    component: _0e03a9b6,
    name: "index___en"
  }, {
    path: "/profile",
    component: _05a04f3f,
    name: "profile___uk"
  }, {
    path: "/ru",
    component: _0e03a9b6,
    name: "index___ru"
  }, {
    path: "/stock",
    component: _d42a69a8,
    name: "stock___uk"
  }, {
    path: "/auth/login",
    component: _52dcac02,
    name: "auth-login___uk"
  }, {
    path: "/en/documentation",
    component: _79a7ced0,
    name: "documentation___en"
  }, {
    path: "/en/profile",
    component: _05a04f3f,
    name: "profile___en"
  }, {
    path: "/en/stock",
    component: _d42a69a8,
    name: "stock___en"
  }, {
    path: "/profile/notifications",
    component: _76201b55,
    name: "profile-notifications___uk"
  }, {
    path: "/profile/password",
    component: _692c6284,
    name: "profile-password___uk"
  }, {
    path: "/ru/documentation",
    component: _79a7ced0,
    name: "documentation___ru"
  }, {
    path: "/ru/profile",
    component: _05a04f3f,
    name: "profile___ru"
  }, {
    path: "/ru/stock",
    component: _d42a69a8,
    name: "stock___ru"
  }, {
    path: "/tasks/archive",
    component: _715e7314,
    name: "tasks-archive___uk"
  }, {
    path: "/tasks/schedule",
    component: _66b52835,
    name: "tasks-schedule___uk"
  }, {
    path: "/en/auth/login",
    component: _52dcac02,
    name: "auth-login___en"
  }, {
    path: "/en/profile/notifications",
    component: _76201b55,
    name: "profile-notifications___en"
  }, {
    path: "/en/profile/password",
    component: _692c6284,
    name: "profile-password___en"
  }, {
    path: "/en/tasks/archive",
    component: _715e7314,
    name: "tasks-archive___en"
  }, {
    path: "/en/tasks/schedule",
    component: _66b52835,
    name: "tasks-schedule___en"
  }, {
    path: "/ru/auth/login",
    component: _52dcac02,
    name: "auth-login___ru"
  }, {
    path: "/ru/profile/notifications",
    component: _76201b55,
    name: "profile-notifications___ru"
  }, {
    path: "/ru/profile/password",
    component: _692c6284,
    name: "profile-password___ru"
  }, {
    path: "/ru/tasks/archive",
    component: _715e7314,
    name: "tasks-archive___ru"
  }, {
    path: "/ru/tasks/schedule",
    component: _66b52835,
    name: "tasks-schedule___ru"
  }, {
    path: "/en/tasks/:uuid?",
    component: _608e796c,
    name: "tasks-uuid___en"
  }, {
    path: "/ru/tasks/:uuid?",
    component: _608e796c,
    name: "tasks-uuid___ru"
  }, {
    path: "/tasks/:uuid?",
    component: _608e796c,
    name: "tasks-uuid___uk"
  }, {
    path: "/",
    component: _0e03a9b6,
    name: "index___uk"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
